import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

import { getUserId, getBrand } from 'data_system/token_auth/selectors';

import { t } from 'services/translation';
import { titleize } from 'lib/string_utils';

import { LOGIN } from './routes';
import { Button } from './elements/Button';
import { ButtonLink } from './elements/ButtonLink';
import { FormFooter } from './FormFooter';
import {
  Label,
  Input,
  Heading,
  Subheading,
  Form,
  FormContainer,
  Error,
  InputSection,
  CenteredLink,
} from './styles_auth';

const ResetPasswordRequestPage = ({ resetPasswordRequest }) => {
  const userId = useSelector(getUserId);
  const { name } = useSelector(getBrand);

  const [email, setEmail] = useState(localStorage.getItem('email') || '');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  useEffect(() => {
    document.title = `${name} - ${t('RESET_PASSWORD')}`;
  }, []);

  const validationSchema = Yup.object().shape({
    email: Yup.string().trim().email('Please enter a valid email address'),
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    validationSchema
      .validate({ email })
      .then((valid) => {
        setSubmitting(true);
        const uid = `${email}+${userId}`;
        resetPasswordRequest({ uid }).finally((res) => {
          setSubmitSuccess(true);
          setSubmitting(false);
        });
      })
      .catch((err) => {
        setError(err.errors);
      });
  };

  const emailInputStep = (
    <React.Fragment>
      <Heading bold>{t('RESET_PASSWORD')}</Heading>
      <Subheading>
        {t(
          'PLEASE_ENTER_YOUR_EMAIL_ADDRESS_WE_LL_SEND_YOU_AN_EMAIL_WITH_INSTRUCTIONS_TO_RESET_YOUR_PASSWORD'
        )}
      </Subheading>
      <Form onSubmit={handleSubmit}>
        <Label>{titleize(t('EMAIL_ADDRESS'))}</Label>
        <InputSection>
          <Input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </InputSection>
        {error ? <Error>{error}</Error> : null}
        <Button disabled={submitting} text={t('SUBMIT')} />
      </Form>

      <CenteredLink to={LOGIN}>{t('RETURN_TO_LOGIN')}</CenteredLink>

      <FormFooter />
    </React.Fragment>
  );

  const submitSuccessStep = (
    <React.Fragment>
      <Heading bold>{t('RESET_PASSWORD_EMAIL_SENT')}</Heading>
      <Subheading>
        {t('WE_JUST_SENT_AN_EMAIL_TO')} <strong>{email}</strong>.{' '}
        {t(
          'PLEASE_CHECK_YOUR_EMAIL_AND_FOLLOW_THE_LINK_TO_RESET_YOUR_PASSWORD'
        )}
      </Subheading>
      <ButtonLink text={t('RETURN_TO_LOGIN')} to={LOGIN} />

      <FormFooter />
    </React.Fragment>
  );

  return (
    <FormContainer>
      {submitSuccess ? submitSuccessStep : emailInputStep}
    </FormContainer>
  );
};

export default ResetPasswordRequestPage;
